import { SDKConfiguration } from "@/inference/setup/config";

const EVENT_NAME = {
  visibilityChange: "helium",
};

export const FBPixelSDK = {
  init() {
    window.fbq("init", SDKConfiguration.PulseFBPixelID);
  },

  flush(payload: any) {
    if (!window.fbq) return;

    const eventName = EVENT_NAME.visibilityChange;

    window.fbq("trackCustom", eventName, payload);
  },

  track(...props: any[]) {
    window.fbq(...props);
  },
};
